import React, { useState, useEffect } from 'react';
import { Table, Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';
import './CampaignsPage.css';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import useTranslations, { getDisplayByEnumKey } from '../transalation/TranslationUtils';
import { campaignStatusMap, getCampaignsByPage, resetAllCampaignPageData, searchCampaignsByPage } from 'app/redux/slices/rdxCampaignSlice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { DEFAULT_IP } from "app/utils/constant";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

const campaignMngeGlbl = {
  coolDown: false
};

const CampaignsPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { campaignManagement,
    campaignName,
    startDate,
    pic,
    createNewCampaign,
    details,
    copy, usersearch, exactmatch, pushreset, role_next, role_previous,
    code, type, pushstatus, func_t, role_delete,
    cmpgnStatusDraft, cmpgnStatusPromotion, cmpgnStatusEnrolment,
    cmpgnStatusInProgress, cmpgnStatusSurvey, i18nObj,
    loadMore, showErrMsg, copyCampaignConfirm, reminder,
    cancel, confirm } = useTranslations();

  const translations = useTranslations();

  const users = useSelector((state) => state.rdxMain?.adminList || {});
  const campaignTypeList = useSelector((state) => state.rdxMain?.campaignTypeList || []);
  const scrolToBottomTS = useSelector((state) => state.rdxMain?.scrolToBottomTS || []);

  const [searchParams, setSearchParams] = useState({
    campaignName: "",
    code: "",
    type: "",
    status: "",
    startDate: "",
    pic: "",
    sis: ""
  });

  const [prevParams, setPrevParams] = useState({
    campaignName: "",
    code: "",
    type: "",
    status: "",
    startDate: "",
    pic: "",
    sis: ""
  });

  const [page, setPage] = useState(0);
  const [hasLoadMore, setHasLoadMore] = useState(false);
  const [copyCampaignId, setCopyCampaignId] = useState(false);
  const [campaignList, setCampaignList] = useState([]);
  const [prevMode, setPrevMode] = useState("normal");
  const [successMessage, setSuccessMessage] = useState("");

  const handleAddMember = () => {
    navigate("/campaigns/mainpage");
  };

  useEffect(() => {
    if (scrolToBottomTS && typeof scrolToBottomTS === "number") {
      if (!campaignMngeGlbl.coolDown) {
        campaignMngeGlbl.coolDown = true;
        console.log("scroll to bottom x", scrolToBottomTS);

        setTimeout(() => {
          campaignMngeGlbl.coolDown = false;
        }, 1000);
      }
    }
  }, [scrolToBottomTS]);

  // Fetch campaign types initially and refresh every 3 seconds
  useEffect(() => {
    //trigger reset search in searchParams's useEffect
    return () => {
      dispatch(resetAllCampaignPageData());
    }
  }, []);

  useEffect(() => {
    if (searchParams) {
      if (searchParams.campaignName != prevParams.campaignName ||
        searchParams.code != prevParams.code ||
        searchParams.type != prevParams.type ||
        searchParams.status != prevParams.status ||
        searchParams.startDate != prevParams.startDate ||
        searchParams.pic != prevParams.pic ||
        searchParams.sis != prevParams.sis) {
        setHasLoadMore(false);
      } else if (!searchParams.campaignName &&
        !searchParams.code &&
        !searchParams.type &&
        !searchParams.status &&
        !searchParams.startDate &&
        !searchParams.pic &&
        !searchParams.sis) {
        //reset search and page init search here
        handleSearch(false);
      }
    }
  }, [searchParams]);

  // Convert Unix timestamp to a human-readable date
  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US");
  };

  const handleDetailsClick = async (campaignId) => {
    navigate("/campaigns/mainpage?campaign_id=" + campaignId);
  };

  const handleDeleteUser = async (campaign) => {
    let campaignName = i18nObj(campaign.campaign_name);
    if (
      window.confirm(
        `Are you sure you want to delete campaign ${campaignName}?`
      )
    ) {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("No token found in localStorage");
        return;
      }

      try {
        const response = await axios.post(
          DEFAULT_IP + "/webapp/memportal/deletecampaign",
          {
            campaign_id: campaign.campaign_id,
          },
          {
            headers: {
              Token: token,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.code === 1) {
          // Remove the deleted campaign from the state
          setCampaignList((prevCampaigns) =>
            prevCampaigns.filter((c) => c.campaign_id !== campaign.campaign_id)
          );

          setSuccessMessage(
            `Campaign ${campaignName} deleted successfully!`
          );
          setTimeout(() => setSuccessMessage(""), 2000);
        } else {
          alert(response.data.message || "Failed to delete campaign.");
        }
      } catch (error) {
        console.error("Error deleting campaign:", error);
        alert("An error occurred while deleting the campaign.");
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "code") {
      // Ensure code is numeric and max 6 digits
      if (/^\d{0,6}$/.test(value)) {
        setSearchParams((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    } else {
      setSearchParams((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSearch = (hasNext) => {
    let isSearchMode = true;
    if (!searchParams.campaignName &&
      !searchParams.code &&
      !searchParams.type &&
      !searchParams.status &&
      !searchParams.startDate &&
      !searchParams.pic &&
      !searchParams.sis) {
      isSearchMode = false;
    }

    let mPage = 1;
    if (!hasNext) {
      setPrevParams(searchParams);
      setPage(mPage);
    } else {
      mPage = page + 1;
      setPage(mPage);
    }

    let callback = (isSuccess, data) => {
      if (isSuccess) {
        if (mPage > 1) {
          console.log("more");
          if (!data.data?.data || data.data?.data.length == 0) {
            setHasLoadMore(false);
          } else {
            setHasLoadMore(true);
            const newList = [...campaignList];
            data.data?.data.forEach((item) => {
              newList.push(item);
            })
            setCampaignList(newList);
          }
        } else {
          console.log("first");
          if (!data.data?.data || data.data?.data.length == 0) {
            setHasLoadMore(false);
          } else {
            setHasLoadMore(true);
          }
          setCampaignList(data.data?.data);
        }
      } else {
        let revertPage = mPage - 1;
        if (revertPage < 1) {
          revertPage = 1;
        }
        setPage(revertPage);
        alert(showErrMsg(data));
      }
    }

    if (isSearchMode) {
      let sendData = {};
      if (searchParams.campaignName) {
        sendData["campaign_name"] = searchParams.campaignName;
      }
      if (searchParams.code) {
        sendData["campaign_code"] = searchParams.code;
      }
      if (searchParams.type) {
        sendData["campaign_type_id"] = searchParams.type;
      }
      if (searchParams.status && "-1" != searchParams.status) {
        sendData["campaign_status"] = parseInt(searchParams.status);
      }
      if (searchParams.sis) {
        sendData["sis"] = searchParams.sis;
      }
      if (searchParams.startDate) {
        sendData["start_date"] = searchParams.startDate;
      }
      if (searchParams.pic) {
        sendData["admin_id"] = searchParams.pic;
      }
      dispatch(searchCampaignsByPage(mPage, sendData, callback));
    } else {
      dispatch(getCampaignsByPage(mPage, callback));
    }
  };



  const handleReset = () => {
    setSearchParams({
      campaignName: "",
      code: "",
      type: "",
      status: "",
      startDate: "",
      pic: "",
      sis: ""
    });

    setPrevParams({
      campaignName: "",
      code: "",
      type: "",
      status: "",
      startDate: "",
      pic: "",
      sis: ""
    });

    //trigger reset search in searchParams's useEffect
  };

  const proceedCopyCampaign = async () => {
    const postRes = await axios.post(DEFAULT_IP + "/webapp/memportal/copycampaign", {
      campaign_id: copyCampaignId
    });
    let data = postRes.data;

    if (1 == data?.code) {
      setCopyCampaignId("");
      navigate("/campaigns/mainpage?campaign_id=" + data.data?.campaign_id);
    } else {
      alert(showErrMsg(data));
    }
  }

  return (
    <Container fluid>

      <Form className="mb-3 p-3 border rounded shadow-custom" style={{ marginTop: '30px' }}>
        <Row className="g-3"> {/* Added spacing between elements */}
          <Col md={3} className="d-flex align-items-center">
            <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}>{campaignName()}:</Form.Label>
            <Form.Control type="text" name="campaignName" value={searchParams.campaignName} onChange={handleInputChange} />
          </Col>
          <Col md={2} className="d-flex align-items-center">
            <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}>{code()}:</Form.Label>
            <Form.Control
              type="text"
              name="code"
              value={searchParams.code}
              onChange={handleInputChange}
            />
          </Col>
          <Col md={2} className="d-flex align-items-center">
            <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}>{type()}:</Form.Label>
            <Form.Select name="type" value={searchParams.type} onChange={handleInputChange}>
              <option value=""></option>
              {campaignTypeList.map((item) => (
                <option key={item.campaign_type_code} value={item.campaign_type_id}>
                  {item.campaign_type_code} ({i18nObj(item.campaign_type_name)})
                </option>))}
            </Form.Select>

          </Col>
          <Col md={2} className="d-flex align-items-center">
            <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}>{pushstatus()}:</Form.Label>
            <Form.Select name="status" value={searchParams.status} onChange={handleInputChange}>
              <option value=""></option>
              <option value="0">{cmpgnStatusDraft()}</option>
              {/* <option>Pending Approval</option>
              <option>Approved</option> */}
              <option value="4">{cmpgnStatusPromotion()}</option>
              {/* <option>Pre-registration</option> */}
              <option value="5">{cmpgnStatusEnrolment()}</option>
              {/* <option>Start</option>
              <option>End</option> */}
              <option value="6">{cmpgnStatusInProgress()}</option>
              <option value="7">{cmpgnStatusSurvey()}</option>

            </Form.Select>
          </Col>
          <Col md={3} className="d-flex align-items-center">
            <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}>{startDate()}:</Form.Label>
            <Form.Control type="date" name="startDate" value={searchParams.startDate} onChange={handleInputChange} />
          </Col>




          <Col md={3} className="d-flex align-items-center">
            <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}>{pic()}:</Form.Label>

            <Form.Select name="pic" value={searchParams.pic} onChange={handleInputChange}>
              <option value=""></option>

              {users.map((item) => (
                <option key={item.admin_id} value={item.admin_id}>
                  {typeof item.admin_name === 'string' ? item.admin_name : item.admin_name?.zh || item.admin_name?.en || 'Unknown'}
                </option>
              ))}
            </Form.Select>

          </Col>


          <Col md={2} className="d-flex align-items-center">
            <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}>SIS : </Form.Label>
            <Form.Select name="sis" value={searchParams.sis} onChange={handleInputChange}>
              <option value=""></option>
              <option>Y</option>
              <option>N</option>
            </Form.Select>
          </Col>
        </Row>

        <Row className="mt-3">


          <Col className="d-flex align-items-center">
            <Button variant="success" className="custom-success-btn me-2" onClick={() => handleSearch(false)}>{usersearch()}</Button>
            <Button variant="success" className="custom-success-btn me-2" onClick={handleReset}>{pushreset()}</Button>
            {/* <Form.Check
              type="checkbox"
              id="exampleCheck"
              label={exactmatch()}
              className="ms-2 exactsearch"
            /> */}
          </Col>



          <Col className='text-end'>
            <Button onClick={handleAddMember} variant="success" className="custom-success-btn " style={{ width: '178px' }}>{createNewCampaign()}</Button>
          </Col>
        </Row>
      </Form>

      {successMessage && (
        <Alert
          variant="success"
          onClose={() => setSuccessMessage("")}
          dismissible
        >
          {successMessage}
        </Alert>
      )}

      <hr />
      <div className="table-responsive">
        <Table striped bordered hover className="mt-4">
          <thead>
            <tr>
              <th className="cmptablehead" style={{ "width": "50%" }}>{campaignName()}</th>
              <th className="cmptablehead" style={{ "whiteSpace": "nowrap" }}>
                <div className=" d-flex justify-content-center align-items-center">
                  {type()}
                </div>
              </th>
              <th className="cmptablehead" style={{ "whiteSpace": "nowrap" }}>
                <div className=" d-flex justify-content-center align-items-center">
                  {code()}
                </div>
              </th>
              <th className="cmptablehead">
                <div className=" d-flex justify-content-center align-items-center">
                  {pushstatus()}
                </div>
              </th>
              <th className="cmptablehead">
                <div className=" d-flex justify-content-center align-items-center">
                  {startDate()}
                </div>
              </th>
              <th className="cmptablehead rwdCampaignBtns">
                <div className="d-flex justify-content-center align-items-center rwdCampaignBtns">
                  {func_t()}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {campaignList.map((campaign, index) => (
              <tr key={index} className="cmptablehead">
                <td>{i18nObj(campaign.campaign_name)}</td>
                <td>
                  <div className=" d-flex justify-content-center align-items-center">
                    {campaign.campaign_type_code}
                  </div>
                </td>
                <td>
                  <div className=" d-flex justify-content-center align-items-center">{campaign.campaign_code}</div></td>
                <td><div className=" d-flex justify-content-center align-items-center">{getDisplayByEnumKey(translations, campaignStatusMap, campaign.campaign_status)}</div></td>
                <td><div className=" d-flex justify-content-center align-items-center">{formatDate(campaign.campaign_start_date)}</div></td>
                <td className="rwdCampaignBtns">
                  <div className="d-flex justify-content-center align-items-center rwdCampaignBtns">
                    <Button variant="success" className="custom-success-btn ms-1 me-1" onClick={() => handleDetailsClick(campaign.campaign_id)}>{details()}</Button>
                    <Button variant="success" className="custom-success-btn ms-1 me-1" onClick={() => setCopyCampaignId(campaign.campaign_id)}>{copy()}</Button>
                    <Button variant="danger" className="custom-danger-btn ms-1 me-1" onClick={() => handleDeleteUser(campaign)}>{role_delete()}</Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {hasLoadMore && (<div className="d-flex justify-content-center">
          <Button variant="outline-success"
            className="custom-outline-success" onClick={() => handleSearch(true)}>{loadMore()}</Button>
        </div>)}
        <div className="mb-5"></div>
      </div>

      <Dialog
        open={(copyCampaignId) ? true : false}
        onClose={() => { setCopyCampaignId(""); }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{reminder()}</DialogTitle>
        <DialogContent>
          <DialogContentText>{copyCampaignConfirm()}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <button className="btn btn-outline-secondary no-hover" onClick={() => { setCopyCampaignId(""); }}>{cancel()}</button>
          <Button variant="primary" onClick={proceedCopyCampaign}>{confirm()}</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default CampaignsPage;
